import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuildingColumns,
  faEarthAmericas,
  faLayerGroup,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";

const QUICK_ACCESS_ITEMS = [
  {
    key: "bank-transfer",
    title: "Bank Transfer",
    icon: faBuildingColumns,
    variant: "bank",
  },
  {
    key: "suyool-transfer",
    title: "Suyool Transfer",
    icon: faPaperPlane,
    variant: "suyool",
  },
  {
    key: "bulk-transfer",
    title: "Bulk Transfer",
    icon: faLayerGroup,
    variant: "bulk",
  },
  {
    key: "international-transfer",
    title: "International Transfer",
    icon: faEarthAmericas,
    variant: "international",
  },
];

export default function QuickAccessCards({ onSelect }) {
  return (
    <section className="make-payment-quick-access" aria-labelledby="quick-access-title">
      <h2 id="quick-access-title">Quick Access</h2>

      <div className="make-payment-quick-access__grid">
        {QUICK_ACCESS_ITEMS.map((item) => (
          <button
            key={item.key}
            type="button"
            className="make-payment-quick-card"
            onClick={() => onSelect?.(item.key)}
          >
            <span
              className={`make-payment-quick-card__icon is-${item.variant}`}
              aria-hidden="true"
            >
              <FontAwesomeIcon icon={item.icon} />
            </span>
            <span>{item.title}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
